import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Buildings, CircleNotch } from '@phosphor-icons/react';

export const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading, activeRole } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-100 flex items-center justify-center">
        <div className="text-center">
          <CircleNotch className="w-12 h-12 text-orange-500 animate-spin mx-auto mb-4" />
          <p className="text-zinc-600">Cargando...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    const target = location.pathname + (location.search || '');
    if (target !== '/dashboard') {
      try { sessionStorage.setItem('mm_post_login_redirect', target); } catch (_) { /* ignore */ }
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check role access if roles specified
  if (allowedRoles.length > 0) {
    const hasAccess = allowedRoles.includes(user.role) || 
                      (user.role === 'ambos' && allowedRoles.includes(activeRole));
    
    if (!hasAccess) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-100 flex items-center justify-center">
        <div className="text-center">
          <Buildings className="w-16 h-16 text-orange-500 mx-auto mb-4" />
          <CircleNotch className="w-8 h-8 text-zinc-400 animate-spin mx-auto" />
        </div>
      </div>
    );
  }

  if (user) {
    const fromLoc = location.state?.from;
    const from = fromLoc?.pathname ? fromLoc.pathname + (fromLoc.search || '') : '/dashboard';
    try { sessionStorage.removeItem('mm_post_login_redirect'); } catch (_) { /* ignore */ }
    return <Navigate to={from} replace />;
  }

  return children;
};
